// Servicios para turnos de imágenes, adaptado de turnosService.js
import { getTurnos, actualizarTurno as actualizarTurnoApi, traerHorariosAtencion } from "../../apiClient/rutes/turnos";
import { ordenarArrayObjetosByDate } from "../../utils/funcionalidadesArrays";

export const obtenerHorariosYTurnosImagenes = async (prestador, usuario, urlAxioPP) => {
  try {
    const { horarios, atiende } = await traerHorariosAtencion(prestador, usuario, urlAxioPP);
    const config = {
      headers: { Authorization: `Bearer ${usuario.token}` },
    };
    const [prestadorCodigo] = prestador.split("-");
    // Aquí deberías adaptar la lógica para estudios si es necesario
    const { turnosDadosMutual, turnosDisponibles } = await getTurnos(usuario.token, prestador, urlAxioPP);
    // Filtrar y ordenar turnos según lógica de imágenes
    const turnosProximos = ordenarArrayObjetosByDate(turnosDisponibles, "fecha");
    return {
      success: true,
      turnosProximos,
      turnosDisponibles,
      fechaSeleccionada: turnosProximos.length > 0 ? turnosProximos[0].fecha : ""
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
      turnosProximos: [],
      turnosDisponibles: [],
      fechaSeleccionada: ""
    };
  }
};

export const manejarReservaTurnoImagenes = async (turnoSeleccionado, usuario, prestadorSeleccionado, urlAxioPP) => {
  try {
    const response = await actualizarTurnoApi(turnoSeleccionado, usuario, prestadorSeleccionado, urlAxioPP);
    if (response.status === 200) {
      return { success: true, mensaje: "El turno se reservó correctamente" };
    } else {
      return { success: false, mensaje: "Ocurrió un problema al intentar reservar el turno" };
    }
  } catch (error) {
    return {
      success: false,
      mensaje: error.response?.data || "Error al reservar el turno: " + error.message
    };
  }
};
